import React from 'react';
import PropTypes from 'prop-types';
import SchoolPride from './SchoolPride';
import CongratulatePopUp from './v3/CongratulatePopUp';

export default function Congratulation({ handleClose, congratulate }) {
  return (
    <>
      <SchoolPride start={congratulate} />
      <CongratulatePopUp handleClose={handleClose} open={congratulate} />
    </>
  );
}

Congratulation.propTypes = {
  congratulate: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
};
